import{createContext as t}from"react";const o=t({transformPagePoint:t=>t,isStatic:!1,reducedMotion:"never"});export{o as MotionConfigContext};
